export default "__VITE_ASSET__e105fbc3__"